import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import PrintingSection from '@/components/feature/sections/PrintingSection'
import FrameShowcaseSection from '@/components/feature/sections/FrameShowcaseSection'
import CtaBand from '@/components/feature/CtaBand'

export default function Printing() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <PageHeader
        breadcrumb={t('pages.printing.breadcrumb')}
        label={t('pages.printing.label')}
        title={t('pages.printing.title')}
        description={t('pages.printing.description')}
        image="https://readdy.ai/api/search-image?query=creative%20print%20and%20design%20studio%20desk%20with%20stacked%20golden%20photo%20frames%2C%20visiting%20cards%2C%20brochures%20and%20colour%20swatches%2C%20warm%20studio%20lighting%2C%20rich%20amber%20and%20cream%20tones%2C%20premium%20editorial%20product%20scene&width=1920&height=900&seq=shabi-hdr-print&orientation=landscape"
        imageAlt="Shabi Media print and design studio with frames, cards and brochures"
      />
      <PrintingSection />
      <FrameShowcaseSection />
      <CtaBand
        eyebrow={t('cta.printing.eyebrow')}
        title={t('cta.printing.title')}
        description={t('cta.printing.description')}
      />
    </SiteLayout>
  )
}